import { getFields, setFields } from '@/services/inqueryServices'

const state = {
  fields: [],
  exportResult: [],
  exportExcelData: []
}

const getters = {
  fieldList (state) {
    let arr = []
    state.fields.forEach(item => {
      if (item.ischecked) {
        arr.push(item.fieldkey)
      }
    })
    return arr
  }
}

const mutations = {
  setFields (state, data) {
    state.fields = data
  },
  UPDATE_RESULT (state, data) {
    state.exportResult = data
  },
  SET_EXPORT_EXCEL_DATA (state, data) {
    state.exportExcelData = data
  }
}

const actions = {
  async fetchFieldConfig ({ commit }) {
    const chain = await getFields().onSuccess(async payload => {
      commit('setFields', payload)
    })
    return chain
  },

  async setFieldConfig ({ commit, dispatch }) {
    const chain = await setFields()
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
